// Copyright (c) Ping. All rights reserved.
//
// TopBar Notes / Tasks tab glyphs (web + default). Encodes the Figma SVG
// as a `data:image/svg+xml` URI and renders it via RN's <Image> — the
// same approach as PingLogomark, because react-native-svg has no runtime
// on react-native-web. The `.macos.tsx` sibling renders via SvgXml.
//
// Props match the TopBar tab-icon contract (`{ size?, color? }`).

import { Image } from 'react-native';
import { buildNotesTabSvg, buildTasksTabSvg } from './tabIconSvgs';

export interface TabIconProps {
  readonly size?: number;
  readonly color?: string;
}

const DEFAULT_COLOR = '#E8EAED';

function toDataUri(svg: string): string {
  const b64 = typeof btoa !== 'undefined' ? btoa(svg) : '';
  return `data:image/svg+xml;base64,${b64}`;
}

export function NotesTabIcon({ size = 16, color = DEFAULT_COLOR }: TabIconProps): JSX.Element {
  return (
    <Image
      source={{ uri: toDataUri(buildNotesTabSvg(size, color)) }}
      style={{ width: size, height: size }}
      resizeMode="contain"
      accessibilityIgnoresInvertColors
    />
  );
}

export function TasksTabIcon({ size = 16, color = DEFAULT_COLOR }: TabIconProps): JSX.Element {
  return (
    <Image
      source={{ uri: toDataUri(buildTasksTabSvg(size, color)) }}
      style={{ width: size, height: size }}
      resizeMode="contain"
      accessibilityIgnoresInvertColors
    />
  );
}
